import React, { useState, useEffect } from 'react';
import { Modal, Table, Tag, Button, Space, message, Descriptions } from 'antd';
import { FilePdfOutlined, EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import dayjs from 'dayjs';

const fmtR = v => (v === null || v === undefined || v === '') ? '-' : 'R$ ' + parseFloat(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 });

export default function ModalVersoes({ propostaId, tipoProposta, open, onClose }) {
  const [versoes, setVersoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [detalhe, setDetalhe] = useState(null);
  const navigate = useNavigate();
  const produto = tipoProposta === 'produto';

  useEffect(() => {
    if (open && propostaId) carregar();
  }, [open, propostaId]);

  const carregar = async () => {
    setLoading(true);
    try {
      const r = await api.get((produto ? '/propostas-produtos/' : '/propostas/') + propostaId + '/versoes');
      setVersoes(r.data || []);
    } catch { message.error('Erro ao carregar versões'); }
    finally { setLoading(false); }
  };

  const baixarPDF = async (v) => {
    try {
      const url = (produto ? '/propostas-produtos/' : '/propostas/') + propostaId + '/pdf';
      const r = await api.get(url, { responseType: 'blob' });
      const blob = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = blob;
      link.setAttribute('download', 'Proposta-' + v.numero + '-Rev' + v.versao + '.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch { message.error('Erro ao baixar PDF'); }
  };

  const colunas = [
    { title: 'Revisão', dataIndex: 'versao', width: 90, render: v => <Tag color="blue">Rev. {v}</Tag> },
    { title: 'Número', dataIndex: 'numero', width: 130 },
    { title: 'Status', dataIndex: 'status', width: 120, render: (v, r) => (
      r.atual ? <Tag color="green">{v} (atual)</Tag> : <Tag>{v || '-'}</Tag>
    )},
    { title: 'Valor', dataIndex: 'valor_total', width: 120, render: fmtR },
    { title: 'Data', dataIndex: 'criado_em', width: 130, render: v => v ? dayjs(v).format('DD/MM/YYYY HH:mm') : '-' },
    { title: 'Ações', width: 130, render: (_, r) => (
      <Space size={4}>
        {r.atual ? (
          <Button size="small" icon={<EyeOutlined />} onClick={() => { onClose(); navigate((produto ? '/propostas-produtos/' : '/propostas/') + propostaId); }}>Ver</Button>
        ) : (
          <Button size="small" icon={<EyeOutlined />} onClick={() => setDetalhe(r)}>Ver</Button>
        )}
        {r.atual && <Button size="small" icon={<FilePdfOutlined />} onClick={() => baixarPDF(r)}>PDF</Button>}
      </Space>
    )},
  ];

  const d = detalhe?.dados || {};
  const itens = Array.isArray(d.itens) ? d.itens : [];
  const colItens = [
    { title: 'Item', render: (_, it) => it.descricao_personalizada || it.descricao || it.servico_nome || it.nome || it.produto_nome || '-' },
    { title: 'Qtd', dataIndex: 'quantidade', width: 70 },
    { title: 'Unit.', width: 120, render: (_, it) => fmtR(it.valor_unitario ?? it.preco_unitario) },
    { title: 'Total', width: 120, render: (_, it) => fmtR(it.valor_total ?? ((parseFloat(it.valor_unitario ?? it.preco_unitario) || 0) * (parseFloat(it.quantidade) || 0))) },
  ];

  return (
    <>
      <Modal title="Versões da Proposta" open={open} onCancel={onClose} footer={null} width={720}>
        <Table columns={colunas} dataSource={versoes} rowKey={r => r.key || r.id} size="small" loading={loading} pagination={false} />
      </Modal>
      <Modal title={detalhe ? 'Proposta ' + (detalhe.numero || '') + ' — Rev. ' + detalhe.versao : ''} open={!!detalhe} onCancel={() => setDetalhe(null)} footer={null} width={760}>
        {detalhe && (
          <>
            <Descriptions size="small" column={2} bordered style={{ marginBottom: 12 }}>
              <Descriptions.Item label="Status">{d.status || '-'}</Descriptions.Item>
              <Descriptions.Item label="Data">{detalhe.criado_em ? dayjs(detalhe.criado_em).format('DD/MM/YYYY HH:mm') : '-'}</Descriptions.Item>
              {d.titulo && <Descriptions.Item label="Título" span={2}>{d.titulo}</Descriptions.Item>}
              {d.subtotal !== undefined && <Descriptions.Item label="Subtotal">{fmtR(d.subtotal)}</Descriptions.Item>}
              {d.desconto !== undefined && <Descriptions.Item label="Desconto">{fmtR(d.desconto)}</Descriptions.Item>}
              {d.valor_imposto !== undefined && <Descriptions.Item label="Imposto">{fmtR(d.valor_imposto)}</Descriptions.Item>}
              <Descriptions.Item label="Total"><strong>{fmtR(d.valor_total)}</strong></Descriptions.Item>
              {d.forma_pagamento && <Descriptions.Item label="Pagamento">{d.forma_pagamento}</Descriptions.Item>}
              {d.condicao_pagamento && <Descriptions.Item label="Pagamento">{d.condicao_pagamento}</Descriptions.Item>}
              {d.validade_dias && <Descriptions.Item label="Validade">{d.validade_dias} dias</Descriptions.Item>}
              {d.observacoes && <Descriptions.Item label="Observações" span={2}>{d.observacoes}</Descriptions.Item>}
            </Descriptions>
            <Table columns={colItens} dataSource={itens} rowKey={(it, i) => it.id || i} size="small" pagination={false} />
          </>
        )}
      </Modal>
    </>
  );
}
